import * as React from 'react';
import { compose, mapProps, withHandlers, withState } from 'recompose';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { reduxForm } from 'redux-form';
import { InputField, Input, AutoCompleteField, AutoComplete } from '@components/form';
import { queryReasonsEnum } from '@components/vehicle/_vehicleEnums';
import { crvLookupVehicle } from '@modules/wantedVehicles/_wantedVehiclesActions';

const validateData = ({ registrationNumber, vinNumber, queryReason }) =>
  (registrationNumber || vinNumber) && queryReason;

const enhance = compose<any, any>(
  withState('showError', 'handleShowError', false),
  mapProps(({ initialValues, ...rest }) => ({
    initialValues: {
      otherDocuments: 'ANY',
      registrationNumberType: 'ANY',
      queryReason: 'CAR_LUSTRATION',
      ...initialValues
    },
    ...rest
  })),
  withHandlers({
    onSubmit: ({
      closeItem,
      changeFieldValue,
      handleLoader,
      handleSnackbar,
      incrementCrvLookupsVersion,
      handleShowError
    }) => async formData => {
      handleLoader(true);

      if (formData.registrationNumber) {
        formData.registrationNumber = formData.registrationNumber.replace(/\s/g, '');
      }

      const isValid = validateData(formData);
      handleShowError(!isValid);
      if (!isValid) {
        handleLoader(false);
        return;
      }

      const response = await crvLookupVehicle(formData);
      if (response) {
        for (const attribute of Object.keys(response)) {
          changeFieldValue(attribute, response[attribute]);
        }
        incrementCrvLookupsVersion();
        handleSnackbar('Údaje předvyplneni z CRV');
        closeItem();
      } else {
        handleSnackbar('Něco se nepovedlo');
      }
      handleLoader(false);
    }
  }),
  reduxForm({
    form: 'module-crv-lookup'
  })
);

const View = ({ closeItem, handleSubmit, showError }) => (
  <div style={{ margin: '15px' }}>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <h4>Lustrace CRV</h4>
        </Row>
        <Row>
          {[
            { label: 'Registrační značka *', name: 'registrationNumber' },
            { label: 'VIN číslo *', name: 'vinNumber' }
          ].map(({ label, name }) => (
            <Col md={6} key={name}>
              <InputField component={Input} name={name} label={label} />
            </Col>
          ))}
          <Col md={6}>
            <AutoCompleteField
              component={AutoComplete}
              items={queryReasonsEnum}
              name={'queryReason'}
              label={'Důvod dotazu *'}
              labelFunction={o => get(o, 'label')}
              valueFunction={o => get(o, 'value')}
            />
          </Col>
        </Row>
        {showError && (
          <Row>
            <h5 style={{ color: 'red' }}>Je potřeba vyplnit registrační značku nebo VIN a zadat důvod dotazu</h5>
          </Row>
        )}
      </Grid>
      <Button label={'Lustrovat'} type="submit" primary={true} style={{ margin: '15px' }} />
      <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
    </form>
  </div>
);

export const CrvLookupsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/components/vehicle/CrvLookupsForm.tsx